(function () {
  const PREVIEW_BADGE_SELECTORS = '.jdgm-prev-badge, .jdgm-preview-badge';
  const REVIEWER_NAME_SELECTOR = '.jm-reviewer-info__name';
  const REVIEWER_MASK_ATTR = 'data-zasuwa-reviewer-masked';
  const MAX_ATTEMPTS = 12;
  let reviewerNameObserver = null;

  function formatAverageRating(value) {
    const numeric = Number(value);
    if (!Number.isFinite(numeric) || numeric <= 0) return '';
    return (Math.round(numeric * 10) / 10).toFixed(1);
  }

  function enhanceBadge(root) {
    if (!root) return false;

    const average = formatAverageRating(root.dataset.averageRating || root.getAttribute('data-average-rating'));
    const count = Math.max(0, Math.floor(Number(root.dataset.numberOfReviews || root.getAttribute('data-number-of-reviews')) || 0));
    const stars = root.querySelector('.jdgm-prev-badge__stars, .jdgm-preview-badge__stars');
    const text = root.querySelector('.jdgm-prev-badge__text, .jdgm-preview-badge__text');

    if (!average || !count || !stars || !text) return false;
    if (root.querySelector('.zasuwa-jdgm-preview-badge__rating')) {
      return true;
    }

    const rating = document.createElement('span');
    rating.className = 'zasuwa-jdgm-preview-badge__rating';
    rating.textContent = average;

    const dot = document.createElement('span');
    dot.className = 'zasuwa-jdgm-preview-badge__dot';
    dot.setAttribute('aria-hidden', 'true');
    dot.textContent = '\u00B7';

    text.before(rating, dot);
    return true;
  }

  function maskReviewerName(value) {
    const normalized = (value || '').trim();

    if (!normalized) return '';

    const characters = Array.from(normalized);

    if (characters.length === 1) {
      return characters[0];
    }

    if (characters.length === 2) {
      return `${characters[0]}*${characters[1]}`;
    }

    return `${characters[0]}***${characters[characters.length - 1]}`;
  }

  function maskReviewerNames(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;

    const nodes = root.matches && root.matches(REVIEWER_NAME_SELECTOR)
      ? [root]
      : Array.from(root.querySelectorAll(REVIEWER_NAME_SELECTOR));

    nodes.forEach((node) => {
      if (!node || node.getAttribute(REVIEWER_MASK_ATTR) === 'true') return;

      const maskedName = maskReviewerName(node.textContent);
      if (!maskedName) return;

      node.textContent = maskedName;
      node.removeAttribute('title');
      node.setAttribute(REVIEWER_MASK_ATTR, 'true');
    });
  }

  function processReviewerNode(node) {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return;

    if (node.matches(REVIEWER_NAME_SELECTOR)) {
      maskReviewerNames(node);
      return;
    }

    if (typeof node.querySelectorAll === 'function') {
      maskReviewerNames(node);
    }
  }

  function observeReviewerNames() {
    if (reviewerNameObserver || !window.MutationObserver || !document.body) return;

    reviewerNameObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((addedNode) => {
          processReviewerNode(addedNode);
        });
      });
    });

    reviewerNameObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function run(attempt = 0) {
    if (!document.body || !document.body.classList.contains('template-product')) return;

    document.querySelectorAll(PREVIEW_BADGE_SELECTORS).forEach((root) => {
      enhanceBadge(root);
    });

    if (attempt === 0) {
      maskReviewerNames(document);
    }
    observeReviewerNames();

    if (attempt < MAX_ATTEMPTS) {
      window.setTimeout(() => run(attempt + 1), 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
